export const formatCurrency = (value) => {
    const number = Number(value || 0);
    return isNaN(number)
      ? '$0.00'
      : `$${number.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
  };
  